import Layout from '../views/layout'
import i18n from '@/lang'

export default {
  path: '/',
  component: Layout,
  hidden: true,
  children: [
    {
      path: 'profile/:tab',
      name: 'profile',
      component: () => import('@pt/views/profile'),
      meta: {
        title: i18n.t('playTurbo.profile.index.title'),
        payment: 'free',
      },
    },
    {
      path: 'plans/detail',
      name: 'plans',
      component: () => import('@pt/views/layout/plans-detail'),
      meta: {
        title: i18n.t('余量详情'),
        payment: 'free',
      },
    },
  ],
}
